module.exports = __webpack_public_path__ + "static/img/role.d03a007.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/media5/role.png
// module id = 2VwX
// module chunks = 7